var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowForward32Dp000000Fill0Wght300Grad0Opsz40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M684.16-454.87H205.13q-10.87 0-18-7.14Q180-469.14 180-480q0-10.87 7.13-18 7.13-7.13 18-7.13h479.03L462.1-726.92q-7.18-7.49-7.39-17.53-.22-10.04 7.6-17.75 7.82-7.72 17.69-7.82 9.87-.11 17.69 7.71l260.44 260.44q4.89 4.9 7.13 10.21 2.23 5.32 2.23 11.69 0 6.38-2.23 11.66-2.24 5.28-7.13 10.18L497.69-197.69q-7.23 7.23-17.34 7.42-10.12.19-18.04-7.42-7.82-7.93-7.82-17.85 0-9.92 7.82-17.49l221.85-221.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward32Dp000000Fill0Wght300Grad0Opsz40);
export default __webpack_public_path__ + "static/media/arrow_forward_32dp_000000_FILL0_wght300_GRAD0_opsz40.c3d3098b0088bfc1f3a6143f964bf5c7.svg";
export { ForwardRef as ReactComponent };